import { DJ_NAME, DJ_BIO_LONG, DJ_GENRE, DJ_STATS } from '../data'
import BookingCTA from '../components/BookingCTA'
import { useMediaQuery, breakpoints } from '../hooks/useMediaQuery'

export default function Bio() {
  const isDesktop = useMediaQuery(breakpoints.lg)

  return (
    <main style={{ minHeight: '100vh' }}>
      <div
        style={{
          padding: isDesktop ? '80px 32px' : '40px 20px',
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: isDesktop ? '1fr 1fr' : '1fr',
          gap: isDesktop ? '80px' : '40px',
          alignItems: 'start',
        }}
      >
        {/* Photo column */}
        <div>
          <div
            style={{
              aspectRatio: '3/4',
              position: 'relative',
              overflow: 'hidden',
              marginBottom: '24px',
              background: '#1a1008',
            }}
          >
            <img
              src="/images/artist-hero.jpg"
              alt="DJ 30Rack"
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                // anchor top so faces stay visible in the 3/4 crop
                objectPosition: 'top center',
              }}
            />

            {/* Subtle bottom fade to blend into stats */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `linear-gradient(180deg,
                  transparent 60%,
                  rgba(13,12,10,0.5) 100%
                )`,
                pointerEvents: 'none',
              }}
            />
          </div>

          {/* Stats */}
          <div style={{ display: 'flex', gap: '32px' }}>
            {DJ_STATS.map((stat) => (
              <div key={stat.label}>
                <div
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontWeight: 700,
                    fontSize: '32px',
                    color: 'var(--gold)',
                    lineHeight: 1,
                  }}
                >
                  {stat.value}
                </div>
                <div
                  style={{
                    fontFamily: 'var(--font-display)',
                    fontSize: '9px',
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                    color: 'var(--gold-dim)',
                    marginTop: '4px',
                  }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bio text */}
        <div>
          <div className="section-label" style={{ marginBottom: '8px' }}>Biography</div>
          <h1
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: '52px',
              textTransform: 'uppercase',
              color: 'var(--cream)',
              lineHeight: 1,
              marginBottom: '32px',
            }}
          >
            {DJ_NAME}
          </h1>

          {/* Genre tags */}
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '32px' }}>
            {DJ_GENRE.map((g) => (
              <span
                key={g}
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '9px',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: 'var(--gold)',
                  border: '1px solid rgba(200,169,110,0.3)',
                  padding: '5px 12px',
                }}
              >
                {g}
              </span>
            ))}
          </div>

          {/* Bio paragraphs */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {DJ_BIO_LONG.split('\n\n').map((para, i) => (
              <p
                key={i}
                style={{
                  fontSize: '15px',
                  lineHeight: 1.85,
                  color: i === 0 ? 'rgba(242,236,224,0.85)' : 'var(--muted)',
                  fontFamily: i === 0 ? 'var(--font-serif)' : 'var(--font-body)',
                }}
              >
                {para}
              </p>
            ))}
          </div>

          {/* Notable residencies */}
          <div
            style={{
              marginTop: '48px',
              paddingTop: '32px',
              borderTop: '1px solid var(--border)',
            }}
          >
            <div className="section-label" style={{ marginBottom: '20px' }}>Notable Residencies & Events</div>
            <ul
              style={{
                listStyle: 'none',
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px 24px',
              }}
            >
              {[
                'Rock the Country Tour',
                'Stagecoach Festival',
                'Country Thunder',
                'EDC Las Vegas',
                'Barefoot Country Music Fest',
                'Carolina Country Music Fest',
                'Billboard Country Live',
              ].map((venue) => (
                <li
                  key={venue}
                  style={{
                    fontSize: '13px',
                    color: 'var(--muted)',
                    paddingLeft: '16px',
                    position: 'relative',
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '4px',
                      height: '4px',
                      borderRadius: '50%',
                      background: 'var(--gold-dim)',
                    }}
                  />
                  {venue}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <BookingCTA />
    </main>
  )
}